// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 116) return "static/chunks/116-7e72687ec2fb2196.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"779":"19c40a323cea29bd","801":"46d38334c31b4c58"}[chunkId] + ".js";
};